module.exports = __webpack_public_path__ + "img/8.435daf14.jpg";